var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Isolation_Mode",
    clipPath: "url(#clip0_1_1868)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M-2.50523e-05 20.4951C-2.50523e-05 16.533 -0.00875775 12.5709 -2.50523e-05 8.60878C0.026173 3.49469 3.52798 -0.00488281 8.66281 -0.00488281C16.5659 -0.00488281 24.4603 -0.00488281 32.3633 -0.00488281C37.4632 -0.00488281 40.9912 3.5296 41 8.63496C41 16.5592 41.0087 24.4834 41 32.4076C41 37.4868 37.4894 40.9864 32.4245 40.9864C24.4603 40.9864 16.496 40.9864 8.53182 40.9864C3.51052 40.9864 0.0349057 37.5043 0.00870764 32.4687C-0.00875775 28.4717 0.00870764 24.4834 0.00870764 20.4864L-2.50523e-05 20.4951ZM21.6571 35.2963V22.5896C22.8709 22.5896 23.9276 22.6245 24.9842 22.5722C25.2637 22.5547 25.7178 22.3278 25.7614 22.1271C26.0583 20.5911 26.2767 19.0464 26.5474 17.3534H21.6396C21.6396 16.1316 21.6396 15.0407 21.6396 13.9498C21.6483 12.3004 22.4954 11.3927 24.1546 11.2706C24.7921 11.2269 25.447 11.2967 26.0845 11.2269C26.3116 11.2007 26.6958 10.9302 26.7046 10.7557C26.757 9.5164 26.7308 8.26842 26.7308 6.74118C25.0279 6.74118 23.456 6.72373 21.8841 6.74118C19.5787 6.77609 17.7972 7.80589 16.889 9.91785C16.3825 11.096 16.2166 12.4487 16.0769 13.7403C15.9459 14.9098 16.0507 16.0967 16.0507 17.3795H11.4573V22.6071H16.0943V35.2876H21.6483L21.6571 35.2963Z",
    fill: "#FF7351"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M21.6571 35.2963H16.1031V22.6158H11.4661V17.3883H16.0595C16.0595 16.1054 15.9547 14.9098 16.0857 13.7491C16.2341 12.4575 16.4 11.1047 16.8978 9.92659C17.7973 7.81463 19.5875 6.78483 21.8929 6.74992C23.4648 6.72374 25.0367 6.74992 26.7395 6.74992C26.7395 8.27716 26.7657 9.52514 26.7133 10.7644C26.7133 10.9389 26.3204 11.2182 26.0933 11.2357C25.4558 11.3055 24.8009 11.2357 24.1634 11.2793C22.5042 11.3927 21.6659 12.3004 21.6484 13.9585C21.6484 15.0494 21.6484 16.1403 21.6484 17.3621H26.5562C26.2854 19.0552 26.0671 20.5999 25.7702 22.1358C25.7353 22.3366 25.2725 22.5635 24.993 22.5809C23.9364 22.6333 22.8797 22.5984 21.6659 22.5984V35.305L21.6571 35.2963Z",
    fill: "#F8F4F2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1868"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 41,
    fill: "white",
    transform: "translate(0 -0.00488281)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.83083f48915220cd0b4326151c21e789.svg";
export { ForwardRef as ReactComponent };